var _feGaussianBlur, _linearGradient, _radialGradient, _radialGradient2, _linearGradient2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionPreviewCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    height: 1.203,
    y: -0.102,
    width: 1.266,
    x: -0.133,
    id: "c",
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.719
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      fillOpacity: 1
    },
    d: "M39 16v25a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h17l11 11z",
    fill: "#50e6ff"
  }), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 10.4,
    y1: 15.472,
    x2: 33.6,
    x1: 28.529,
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3079d6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297cd2",
    offset: 1
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ccc",
      fillOpacity: 1
    },
    d: "M28 5v9a2 2 0 0 0 2 2h9L28 5z",
    fill: "url(#a)"
  }), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    gradientUnits: "userSpaceOnUse",
    r: 10.085,
    cy: 36.04,
    cx: 36.108,
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006185",
    offset: 0.354
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1a8dad",
    offset: 0.538
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41cde8",
    offset: 0.826
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50e6ff",
    offset: 0.962
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fillOpacity: 0.48387095,
      fill: "#a8a8a8",
      filter: "url(#c)"
    },
    d: "M36 26c-5.523 0-10 4.477-10 10a9.962 9.962 0 0 0 2.864 7H37a2 2 0 0 0 2-2V26.459A10.011 10.011 0 0 0 36 26z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e7e7e",
      fillOpacity: 1
    },
    d: "m43.992 42.224-1.768 1.768 3.935 3.935a.25.25 0 0 0 .354 0l1.414-1.414a.25.25 0 0 0 0-.354l-3.935-3.935z",
    fill: "#199be2"
  }), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    r: 9.802,
    cy: 36.048,
    cx: 36.012,
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006185",
    offset: 0.693
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35c1f1",
    offset: 0.921
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fillOpacity: 1,
      fill: "#434343"
    },
    fill: "url(#b)",
    d: "M41.8 40.033 40.033 41.8l2.191 2.192 1.768-1.768z"
  }), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 41.669,
    y1: 30.455,
    x2: 41.669,
    x1: 30.455,
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a3ffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9dfbff",
    offset: 0.223
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8bf1ff",
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ee0ff",
    offset: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63daff",
    offset: 1
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#e0e0e0",
      fillOpacity: 1
    },
    fill: "url(#e)",
    r: 8,
    cy: 36,
    cx: 36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9 46.827 47.197 25.53c.08-.08.21-.08.29 0l.868.869c.08.08.08.21 0 .29L27.06 47.984c-.08.08-.21.08-.29 0l-.869-.869a.205.205 0 0 1 0-.29z",
    fill: "#e52030",
    style: {
      strokeWidth: 0.537463
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionPreviewCancel);
export default __webpack_public_path__ + "static/media/actionPreviewCancel.939f24c7b498ac6d2dbff92bbffac244.svg";
export { ForwardRef as ReactComponent };